<template>
  <Modal @close="close" :notCloseBg="true" variant="dashboard">
    <template slot="content">
      <div class="p-dashboard-form">
        <div class="p-dashboard-form__header">
          <h2 class="p-dashboard-form__title">
            検索順位チェックに追加しましょう
          </h2>
        </div>
        <div class="p-dashboard-form__content">
          <template>
            <div class="c-fieldset c-fieldset--wrap">
              <div class="c-fieldset__header">
                <p class="c-fieldset__title">
                  「検索順位チェック」にキーワードを追加すると、順位を定点観測することができます。
                </p>
              </div>
              <div class="c-fieldset__content c-alertPos">
                <Input
                  v-model="item.keyword"
                  placeholder="キーワードは編集できません"
                  readonly
                />
              </div>
            </div>
          </template>
        </div>
        <div class="p-dashboard-form__footer c-alertPos">
          <Button
            class="p-dashboard-form"
            @click="submit"
            size="w260"
            fsizse="f16"
            variant="green"
            :disabled="isProcessing"
            radius
            :class="{ 'is-loading': isProcessing }"
          >
            検索順位チェックに追加する
          </Button>
          <Alert v-if="errorResponse">
            {{ errorResponse }}
          </Alert>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import { ERROR_MESSAGE, USAGE_LABEL, USAGE_COUNT_LABEL } from '@/constants';
import Alert from '@/components/Alert';
import Button from '@/components/Button';
import Input from '@/components/Input';
import Modal from '@/components/Modal';
import apiProjects from '@/api/projects';
import Validation from '@/validation';

export default {
  props: {
    item: {
      type: Object,
      required: true
    },
    project: {
      type: Object,
      required: true
    }
  },
  components: {
    Alert,
    Button,
    Input,
    Modal
  },
  data() {
    return {
      errorResponse: '',
      isProcessing: false
    };
  },
  methods: {
    close() {
      this.$emit('close');
    },
    async submit() {
      //検索順位チェックの登録処理
      const params = this.getTaskParams();

      this.isProcessing = true;

      // 利用量を取得
      await this.getUsages()
        .then(response => {
          const usages = response[0].data.items[0]; //登録数
          const usagesCount = response[1].data; //登録回数

          if (usagesCount.current + 1 > usagesCount.max) {
            this.errorResponse = `${USAGE_COUNT_LABEL['observation-keywords']}の上限を超えています`;
          } else if (usages.current + 1 > usages.max) {
            this.errorResponse = `${USAGE_LABEL['observation-keywords']}の上限を超えています`;
          }
        })
        .catch(error => {
          if (error.response) {
            this.errorResponse = [error.response.data.errors[0].userMessage];
          }
        });

      if (this.errorResponse) {
        this.isProcessing = false;
        return;
      }

      apiProjects.observationKeywords
        .post(params, this.auth.idToken, this.project.id, this.item.id)
        .then(response => {
          const item = Object.assign({}, this.item);
          item.keyword = params.keyword;
          item.url = params.url;
          this.close();
          this.isProcessing = false;
        })
        .catch(error => {
          if (error.response && error.response.data) {
            this.errorResponse = error.response.data.errors[0].userMessage;
          } else {
            this.errorResponse = ERROR_MESSAGE.other;
          }
          this.isProcessing = false;
        });
    },
    getUsages() {
      return Promise.all([this.getUsagesKeywords(), this.getUsagesCount()]);
    },
    getUsagesKeywords() {
      const params = {
        items: 'observation-keywords'
      };
      return apiProjects.usages.get(params, this.auth.idToken, this.project.id);
    },
    getUsagesCount() {
      const params = {
        items: 'observation-keywords'
      };
      return apiProjects.usages.count.get(
        params,
        this.auth.idToken,
        this.project.id
      );
    },
    getTaskParams() {
      const params = {
        url: this.item.url,
        keyword: this.item.keyword
      };
      return params;
    }
  }
};
</script>
